import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Button } from 'antd';

import { hasPermission } from '../../../helpers/user';

import { PERMISSIONS } from '../../../constants/permissions';

const useTaskActions = ({ permissions = [], onAddTaskClick, clearFilters }) => {
  const { selectedFilters } = useSelector(state => state.filters);

  return useMemo(() => {
    const availableActions = [];

    if (hasPermission([PERMISSIONS.TASKS.CREATE], permissions)) {
      availableActions.push({
        label: (
          <Button color="default" size="small" variant="link" onClick={onAddTaskClick}>
            Add task
          </Button>
        )
      });
    }

    availableActions.push({
      label: (
        <Button
          color="default"
          size="small"
          variant="link"
          disabled={selectedFilters && !Object.values(selectedFilters)?.length}
          onClick={clearFilters}>
          Clear all filters
        </Button>
      )
    });

    return availableActions;
  }, [permissions, clearFilters, onAddTaskClick]);
};

export default useTaskActions;
